const resolveDisplayName = (entity) => entity?.display_name
  || entity?.displayName
  || entity?.name
  || entity?.contact_name
  || [entity?.client_first_name, entity?.client_last_name].filter(Boolean).join(' ')
  || entity?.client_name
  || [entity?.first_name, entity?.last_name].filter(Boolean).join(' ')
  || '';

const buildEntityTopicTitle = (entity) => {
  const displayName = resolveDisplayName(entity);
  if (entity?.type === 'appointment') return displayName ? `Appointment with ${displayName}` : 'Appointment';
  if (entity?.type === 'matter') return displayName || 'Matter';
  if (entity?.type === 'payment_request') return 'Payment request';
  const type = entity?.type || '';
  return [type, displayName].filter(Boolean).join(': ') || type;
};

const resolveRadioSelectionText = (entity) => {
  if (entity?.title) return entity.title;
  return resolveDisplayName(entity) || entity?.uid || '';
};

export { resolveRadioSelectionText };
export default buildEntityTopicTitle;
